import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import api from "api/api";
import { CUSTOMERS, CATEGORIES } from "constants/ApiRoutes";
import { PRODUCTS } from "constants/ApiRoutes";

const SearchContext = createContext([]);

const SearchProvider = ({ children }) => {
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseCustomers, setResponseCustomers] = useState([]);

  const searchCustomer = async (search_customer = "") => {
    setLoading(true);
    await api
      .get(`${CUSTOMERS}/search?search_customer=${search_customer}`)
      .then((res) => {
        setResponseCustomers(res.data);
      })
      .finally(() => setLoading(false));
  };

  const searchCategory = async (search_category = "") => {
    await api.get(`${CATEGORIES}/search?search_category=${search_category}`).then((response) => {
      setResponse(response.data);
    });
  };

  const searchProducts = async (search_product = "") => {
    await api.get(`${PRODUCTS}/search?search_product=${search_product}`).then((response) => {
      setResponse(response.data);
    });
  };

  return (
    <SearchContext.Provider
      value={{
        searchCustomer,
        searchCategory,
        searchProducts,
        response,
        setResponse,
        responseCustomers,
        setResponseCustomers,
        loading,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};

export { SearchProvider, useSearch };

SearchProvider.propTypes = {
  children: PropTypes.element,
};
